import React from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { Fade, Zoom } from "react-reveal";
import "./Certifications.css";
import CertificationCard from "../../components/certificationCard/CertificationCard";
import { t } from "i18next";

function Certifications(props) {
  const theme = props.theme;
  const certifications = {
    certifications: [
      {
        title: "PrimusLabs",
        subtitle: t("sections.certifications.3"),
        logo_path: "logo_cert-primus.jpg",
        certificate_link: "https://primusgfs.com/",
        alt_name: "PrimusLabs",
        // color_code: "#2AAFED",
        color_code: props.theme.name === "light" ? "#000000" : "#FFFFFF",
      },
      {
        title: "SMETA",
        subtitle: t("sections.certifications.4"),
        logo_path: "logo_cert-sedex-smeta.jpg",
        certificate_link: "https://www.sedex.com/solutions/smeta-audit/",
        alt_name: "SMETA",
        color_code: props.theme.name === "light" ? "#000000" : "#FFFFFF",
      },
    ],
  };
  return (
    <div className="privacy-main">
      <Header theme={theme} setTheme={props.setTheme} />
      <div className="basic-projects">
        <Fade bottom duration={2000} distance="40px">
          <div className="privacy-heading-div">
            <div className="privacy-heading-text-div">
              <h1
                className="privacy-heading-text"
                style={{ color: theme.text }}
              >
                {t("titles.certifications")}
              </h1>
            </div>
          </div>
        </Fade>
        <div>
          <div className="skills-main-div">
            <Fade left duration={2000}>
              <div className="skills-image-div">
                <img
                  src={require(`../../assests/images/sangabriel/img_finca3.jpg`)}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    boxSizing: "border-box",
                    marginTop: "10%",
                  }}
                  alt="Lemon"
                  fill={theme.accentColor}
                />
              </div>
            </Fade>

            <div className="skills-text-div">
              <Fade right duration={2000}>
                <div>
                  <p
                    className="subTitle skills-text"
                    style={{ color: theme.secondaryText }}
                  >
                    {t("sections.certifications.1")}
                  </p>
                </div>
              </Fade>
            </div>
          </div>
        </div>

        <div>
          <div className="skills-main-div">
            <div className="skills-text-div">
              <Zoom right duration={2000}>
                <div>
                  <p
                    className="subTitle skills-text"
                    style={{ color: theme.secondaryText }}
                  >
                    {t("sections.certifications.2")}
                  </p>
                </div>
              </Zoom>
            </div>
          </div>
        </div>

        <div className="main" id="certs">
          <div className="certs-header-div">
            <Fade bottom duration={2000} distance="20px">
              <h1 className="certs-header" style={{ color: theme.text }}>
                {t("titles.Certifications")}
              </h1>
            </Fade>
          </div>
          <div className="certs-body-div">
            {certifications.certifications.map((cert) => {
              return <CertificationCard certificate={cert} theme={theme} />;
            })}
          </div>
        </div>
      </div>
      <Footer theme={props.theme} onToggle={props.onToggle} />
    </div>
  );
}

export default Certifications;
